import React from "react";
import styles from "./TextScroll.module.css";

console.log(styles.textoutline);
const TextScroll = () => {
	return (
		<div className="flex w-full bg-purple-900">
			<div className="overflow-hidden">
				<div className="w-full animate-scroll-text break-normal whitespace-nowrap flex lg:py-5 py-2 ">
					<h1
						className={`lg:py-5 py-2 lg:text-8xl text-4xl font-bold uppercase ${styles.textoutline} `}
					>
						MEDUSA{" "}
					</h1>
					<span className=" lg:py-5 py-2 lg:text-8xl text-4xl font-bold text-black uppercase">
						MEDUSA
					</span>
					<h1
						className={`lg:py-5 py-2 lg:text-8xl text-4xl font-bold uppercase ${styles.textoutline} `}
					>
						MEDUSA{" "}
					</h1>
					<span className=" lg:py-5 py-2 lg:text-8xl text-4xl font-bold text-black uppercase">
						MEDUSA
					</span>
					<h1
						className={`lg:py-5 py-2 lg:text-8xl text-4xl font-bold uppercase ${styles.textoutline} `}
					>
						MEDUSA{" "}
					</h1>
					<span className=" lg:py-5 py-2 lg:text-8xl text-4xl font-bold text-black uppercase">
						MEDUSA
					</span>
					<h1
						className={`lg:py-5 py-2 lg:text-8xl text-4xl font-bold uppercase ${styles.textoutline} `}
					>
						MEDUSA{" "}
					</h1>
					<span className=" lg:py-5 py-2 lg:text-8xl text-4xl font-bold text-black uppercase">
						MEDUSA
					</span>
					<h1
						className={`lg:py-5 py-2 lg:text-8xl text-4xl font-bold uppercase ${styles.textoutline} `}
					>
						MEDUSA{" "}
					</h1>
					<span className=" lg:py-5 py-2 lg:text-8xl text-4xl font-bold text-black uppercase">
						MEDUSA
					</span>
					<h1
						className={`lg:py-5 py-2 lg:text-8xl text-4xl font-bold uppercase ${styles.textoutline} `}
					>
						MEDUSA{" "}
					</h1>
					<span className=" lg:py-5 py-2 lg:text-8xl text-4xl font-bold text-black uppercase">
						MEDUSA
					</span>
					<h1
						className={`lg:py-5 py-2 lg:text-8xl text-4xl font-bold uppercase ${styles.textoutline} `}
					>
						MEDUSA{" "}
					</h1>
					<span className=" lg:py-5 py-2 lg:text-8xl text-4xl font-bold text-black uppercase">
						MEDUSA
					</span>
					<h1
						className={`lg:py-5 py-2 lg:text-8xl text-4xl font-bold uppercase ${styles.textoutline} `}
					>
						MEDUSA{" "}
					</h1>
					<span className=" lg:py-5 py-2 lg:text-8xl text-4xl font-bold text-black uppercase">
						MEDUSA
					</span>
					<h1
						className={`lg:py-5 py-2 lg:text-8xl text-4xl font-bold uppercase ${styles.textoutline} `}
					>
						MEDUSA{" "}
					</h1>
					<span className=" lg:py-5 py-2 lg:text-8xl text-4xl font-bold text-black uppercase">
						MEDUSA
					</span>

					<h1
						className={`lg:py-5 py-2 lg:text-8xl text-4xl font-bold uppercase ${styles.textoutline} `}
					>
						MEDUSA{" "}
					</h1>
					<span className=" lg:py-5 py-2 lg:text-8xl text-4xl font-bold text-black uppercase">
						MEDUSA
					</span>
					<h1
						className={`lg:py-5 py-2 lg:text-8xl text-4xl font-bold uppercase ${styles.textoutline} `}
					>
						MEDUSA{" "}
					</h1>
					<span className=" lg:py-5 py-2 lg:text-8xl text-4xl font-bold text-black uppercase">
						MEDUSA
					</span>
					<h1
						className={`lg:py-5 py-2 lg:text-8xl text-4xl font-bold uppercase ${styles.textoutline} `}
					>
						MEDUSA{" "}
					</h1>
					<span className=" lg:py-5 py-2 lg:text-8xl text-4xl font-bold text-black uppercase">
						MEDUSA
					</span>
				</div>
			</div>
		</div>
	);
};

export default TextScroll;
